import { MetaTags } from "react-meta-tags";

const Metatags = (props) => {
  const metatags = props.metatags;
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://appupgrade.dev/#organization",
        name: "App Upgrade",
        url: "https://appupgrade.dev",
        logo: {
          "@type": "ImageObject",
          url: "https://appupgrade.dev/logo.png",
        },
        sameAs: [
          "https://twitter.com/app_upgrade",
          "https://github.com/appupgrade-dev",
          "https://www.youtube.com/channel/UC0ZVJPYHFVuMwEsro4VZKXw",
        ],
      },
      {
        "@type": "SoftwareApplication",
        "@id": "https://appupgrade.dev/#software-application",
        name: "App Upgrade",
        applicationCategory: "DeveloperApplication",
        operatingSystem: "Android, iOS, React Native, Flutter, Expo",
        url: "https://appupgrade.dev",
        description:
          "App Upgrade helps mobile teams prompt or force app updates across Android, iOS, React Native, Flutter, Expo, Huawei AppGallery, Amazon Appstore, and custom marketplaces.",
        creator: {
          "@id": "https://appupgrade.dev/#organization",
        },
        softwareHelp: "https://appupgrade.dev/docs/",
        downloadUrl: [
          "https://www.npmjs.com/package/app-upgrade-react-native-sdk",
          "https://pub.dev/packages/app_upgrade_flutter_sdk",
          "https://github.com/appupgrade-dev/app-upgrade-android-sdk",
          "https://github.com/appupgrade-dev/app-upgrade-ios-sdk",
        ],
        featureList: [
          "Force app upgrades",
          "Recommended app updates",
          "Custom update messages",
          "Message localization",
          "Custom attributes for targeting",
          "SDK and API integrations",
        ],
      },
      {
        "@type": "Product",
        "@id": "https://appupgrade.dev/#product",
        name: "App Upgrade",
        brand: {
          "@id": "https://appupgrade.dev/#organization",
        },
        category: "Mobile app update management software",
        url: "https://appupgrade.dev",
        description:
          "App Upgrade helps mobile teams prompt or force app updates across Android, iOS, React Native, Flutter, Expo, Huawei AppGallery, Amazon Appstore, and custom marketplaces.",
        offers: {
          "@type": "Offer",
          url: "https://appupgrade.dev/pricing",
          priceCurrency: "USD",
          availability: "https://schema.org/InStock",
        },
      },
      {
        "@type": "WebPage",
        "@id": `${metatags.url}#webpage`,
        url: metatags.url,
        name: metatags.title,
        description: metatags.description,
        isPartOf: {
          "@type": "WebSite",
          "@id": "https://appupgrade.dev/#website",
          name: "App Upgrade",
          url: "https://appupgrade.dev",
        },
        about: {
          "@id": "https://appupgrade.dev/#software-application",
        },
      },
    ],
  };

  return (
    <MetaTags>
      <title>{metatags.title}</title>
      <link rel="canonical" href={metatags.url} />

      <meta name="title" content={metatags.title} />
      <meta name="description" content={metatags.description} />
      <meta name="keywords" content="App Upgrade, App Upgrade Manager, App Version Manager, Google Play Store App Update, App Store Updates, App Updates, Version Updates, Upgrade-Wall, Update-Wall, Huawei, Huawei AppGallery, Amazon Appstore" />
      <meta property="og:image" content={metatags.image} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={metatags.url} />
      <meta property="og:title" content={metatags.title} />
      <meta property="og:description" content={metatags.description} />
      <meta property="og:image" content={metatags.image} />

      <meta property="twitter:card" content={metatags.image} />
      <meta property="twitter:site" content="@app_upgrade"></meta>
      <meta property="twitter:url" content={metatags.url} />
      <meta property="twitter:title" content={metatags.title} />
      <meta property="twitter:description" content={metatags.description} />
      <meta property="twitter:image" content={metatags.image} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </MetaTags>
  );
};

export default Metatags;
